module.exports = __webpack_public_path__ + "static/img/third2_1_3.9ff07863.jpg";